

























































import { Component, Vue } from "vue-property-decorator";
import Textfield from "@/components/Textfield.vue";
import Button from "@/components/Button.vue";
import Message from "@/components/Message.vue";
import { Action } from "vuex-class";
import { AxiosResponse } from "axios";

const namespace = "auth";

@Component({
  components: {
    appTextfield: Textfield,
    appButton: Button,
    appMessage: Message
  }
})
export default class Account extends Vue {
  @Action("setToken", { namespace }) setToken!: (token: string) => void;

  currentPassword = "";
  newPassword = "";
  errors: Array<{ msg: string }> = [];
  open = false;
  loading = false;

  onSubmit() {
    this.loading = true;
    this.axios
      .put("/api/auth/update-password", {
        currentPassword: this.currentPassword,
        newPassword: this.newPassword
      })
      .then((response: AxiosResponse<{ token: string }>) => {
        this.loading = false;
        this.open = true;
        this.errors = [];
        this.setToken(response.data.token);
      })
      .catch(
        ({
          response
        }: {
          response: AxiosResponse<{ errors: Array<{ msg: string }> }>;
        }) => {
          response = response as AxiosResponse<{
            errors: Array<{ msg: string }>;
          }>;
          this.loading = false;
          this.open = true;
          this.errors = response.data.errors;
        }
      );
    this.currentPassword = "";
    this.newPassword = "";
  }
}
